// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__62PhZ","description":"PatientConsentPreview_description__3OvhU"};